import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "h-full shadow-md bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = { class: "w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VueApexCharts, {
        class: "pt-2 mx-4",
        height: "95%",
        options: _ctx.chartOptions,
        series: _ctx.heatMapPresenter.heatMapSeries.value,
        type: "heatmap"
      }, null, 8, ["options", "series"])
    ])
  ]))
}